module.exports = __webpack_public_path__ + "img/activity-bg3.49289858.png";